/* global Swiper */
// *******************************************************************************
// Product List
// *******************************************************************************

const productListSliderElements = document.querySelectorAll('[data-slider="product-list-slider"]');

const productListSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 14,
  freeMode: true,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    992: {
      allowTouchMove: false,
      noSwiping: false,
      spaceBetween: 16,
    },
  },
};

productListSliderElements.forEach((el) => {
  const productListSliderParent = el.closest('.sc-product-list');
  const paginationElement = productListSliderParent.querySelector('.swiper-pagination');
  productListSliderOptions.pagination.el = paginationElement;
  // eslint-disable-next-line no-new
  new Swiper(el, productListSliderOptions);
});
